import React from 'react';
import Icon from '../../../components/AppIcon';

const RedemptionCard = ({ redemption, userPoints, hasProAccess, onRedeem }) => {
  const canAfford = userPoints >= redemption?.pointCost;
  const isLocked = redemption?.requiresPro && !hasProAccess;

  const getBenefitIcon = (benefitType) => {
    const icons = {
      pro_discount: 'Percent',
      free_month: 'Calendar',
      feature_unlock: 'Unlock',
      premium_report: 'FileText',
      partner_reward: 'Gift'
    };
    return icons?.[benefitType] || 'Gift';
  };

  const getBenefitColor = (benefitType) => {
    const colors = {
      pro_discount: 'var(--color-success)',
      free_month: 'var(--color-primary)',
      feature_unlock: 'var(--color-accent)',
      premium_report: 'var(--color-warning)',
      partner_reward: 'var(--color-secondary)'
    };
    return colors?.[benefitType] || 'var(--color-muted-foreground)';
  };

  return (
    <div className={`bg-card rounded-lg p-20 shadow-elevation-2 transition-smooth ${
      isLocked ? 'opacity-60' : 'hover:shadow-elevation-3'
    }`}>
      <div className="flex items-start justify-between mb-16">
        <div 
          className="flex items-center justify-center w-12 h-12 rounded-lg"
          style={{ backgroundColor: `${getBenefitColor(redemption?.benefitType)}15` }}
        >
          <Icon 
            name={getBenefitIcon(redemption?.benefitType)} 
            size={24} 
            color={getBenefitColor(redemption?.benefitType)} 
            strokeWidth={2.5} 
          />
        </div>
        {redemption?.requiresPro && (
          <span className="inline-flex items-center gap-4 px-8 py-4 bg-primary/10 text-primary rounded text-xs font-medium">
            <Icon name="Crown" size={12} />
            Pro
          </span>
        )}
      </div>

      <h3 className="text-lg font-heading font-semibold text-card-foreground mb-8">
        {redemption?.title}
      </h3>

      <p className="text-sm text-muted-foreground mb-20">
        {redemption?.description}
      </p>

      <div className="flex items-center justify-between mb-16">
        <div className="flex items-center gap-6">
          <Icon name="Coins" size={18} color="var(--color-primary)" />
          <span className="text-xl font-heading font-bold text-primary">
            {redemption?.pointCost?.toLocaleString()}
          </span>
        </div>
        {!canAfford && !isLocked && (
          <span className="text-xs text-destructive font-medium">
            Need {(redemption?.pointCost - userPoints)?.toLocaleString()} more
          </span>
        )}
      </div>

      <button
        onClick={onRedeem}
        disabled={!canAfford || isLocked}
        className={`w-full px-16 py-12 rounded-lg font-medium transition-smooth min-h-[44px] flex items-center justify-center gap-8 ${
          isLocked
            ? 'bg-muted text-muted-foreground cursor-not-allowed'
            : canAfford
            ? 'bg-primary text-primary-foreground hover:bg-primary/90'
            : 'bg-muted text-muted-foreground cursor-not-allowed'
        }`}
      >
        {isLocked ? (
          <>
            <Icon name="Lock" size={16} />
            Pro Required
          </>
        ) : canAfford ? (
          <>
            <Icon name="ShoppingCart" size={16} />
            Redeem Now
          </>
        ) : (
          <>
            <Icon name="AlertCircle" size={16} />
            Insufficient Points
          </>
        )}
      </button>
    </div>
  );
};

export default RedemptionCard;